import React from "react";
import Message from "./Message";
import ChatInput from "./ChatInput";
import SettingsButton from "./SettingsButton";
import { FaBolt } from "react-icons/fa";
import "../styles/ChatUI.css";

const ChatUI = ({
  messages,
  inputMessage,
  setInputMessage,
  sendMessage,
  formatMessageContent,
  messagesEndRef,
  onReportResponse,
  selectedProfileUuid,
  userInfo,
}) => {
  return (
    <div className="chat-ui">
      <div className="chat-messages">
        {messages.map((message) => (
          <Message
            key={message.id || `${message.role}-${message.content.substring(0, 50)}`}
            message={message}
            formatMessageContent={formatMessageContent}
            onReportResponse={onReportResponse}
            messages={messages}
            selectedProfileUuid={selectedProfileUuid}
            userInfo={userInfo}
          />
        ))}
        <div ref={messagesEndRef}></div>
      </div>
      <ChatInput
        inputMessage={inputMessage}
        setInputMessage={setInputMessage}
        sendMessage={sendMessage}
      />
      <SettingsButton />
    </div>
  );
};

export default ChatUI;